import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CopyButton({ value, label }: { value: string; label?: string }) {
  const { t } = useTranslation();
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');
  const text = label ?? t('common.copy');

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setState('copied');
    } catch {
      setState('failed');
    }

    window.setTimeout(() => setState('idle'), 2000);
  }

  const icon = state === 'copied' ? 'pi-check' : state === 'failed' ? 'pi-times' : 'pi-copy';

  return (
    <button
      type="button"
      className="btn btn-link btn-sm copy-button"
      onClick={copy}
      aria-label={`${text} ${value}`}
    >
      <i className={`pi ${icon} me-1`} aria-hidden="true" />
      {state === 'copied' ? t('common.copied') : state === 'failed' ? t('common.copyFailed') : text}
    </button>
  );
}
